import { createSlice } from '@reduxjs/toolkit';
import { fetchAreas, fetchSavedDeliverySettings, logoutAdmin, logoutUser } from '~/api';

/**
areas: [
  {
    areaCd: '101',
    areaNm: '北海道',
    areaNmEn: 'Hokkaido',
    areaNmZh: '北海道',
    children: [
      {
        areaCd: '01',
        areaNm: '北海道',
        areaNmEn: 'Hokkaido',
        areaNmZh: '北海道',
        parentAreaCd: '101',
      },
    ],
  },
  ...
];
*/

const initialState = {
  areas: [],
};

/**
 * 割付（配信対象者）データ管理用Slice。
 */
const areasSlice = createSlice({
  name: 'areas',
  initialState,
  reducers: {},
  // 非同期はextraReducersで行う
  extraReducers: {
    [fetchAreas.fulfilled.type]: (_, action) => {
      return {
        areas: action.payload.areas,
      };
    },
    [fetchSavedDeliverySettings.fulfilled.type]: (_, action) => {
      return {
        areas: action.payload.areas,
      };
    },
    [logoutAdmin.fulfilled.type]: () => {
      return initialState;
    },
    [logoutUser.fulfilled.type]: () => {
      return initialState;
    },
  },
});

// reducerをexportする
export default areasSlice.reducer;
